import { ChangeEvent, useState } from "react";
import "./RadioButton.scss";

interface RadioButtonOptionsProps {
  label: string;
  value: string;
}

interface RadioButtonProps {
  options: RadioButtonOptionsProps[];
  onChange: (value: string) => void;
}

const RadioButton: React.FC<RadioButtonProps> = (props) => {
  const { onChange, options } = props;
  const [selectedValue, setSelectedValue] = useState<string>("");

  const onChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (onChange) onChange(value);

    setSelectedValue(value);
  };

  return (
    <div className="radio-button-group">
      {options.map((option) => {
        const checked = option.value === selectedValue;
        return (
          <div className="radio-button-control">
            <span
              className={` ${
                checked ? "texto-colorido" : "label-cinza"
              }  label`}
            >
              {option.label}
            </span>
            <label key={option.value}>
              <div className={`radio-button ${checked && "checked"}`}>
                <input
                  type="radio"
                  name="radio-button"
                  value={option.value}
                  onChange={onChangeValue}
                />
                {checked && <div className="checked"></div>}
              </div>
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default RadioButton;
